module.exports = "<p>\n  leave-encashment-rec-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/employee-claims/leave-encashment-rec/leave-encashment-rec-form/leave-encashment-rec-form.component.html
// module id = ./src/app/hrms/employee-claims/leave-encashment-rec/leave-encashment-rec-form/leave-encashment-rec-form.component.html
// module chunks = main